import { createReducer, Action, on } from '@ngrx/store';
import { DocTitlebar } from 'src/app/core/models/app-state.models';
import { titlebarActions } from '../actions';


const initialState: DocTitlebar = {
    title: '',
    hideNotifications: false,
    enableBack: false,
    hideMenu: false
}


export const appReducer = createReducer(
    initialState,
    on(titlebarActions.setTitlebarTitle, (state, action) => ({ ...state, title: action.title })),
    on(titlebarActions.setTitlebarNotification, (state, action) => ({ ...state, hideNotifications: action.status })),
    on(titlebarActions.setTitlebarBackNav, (state, action) => ({ ...state, enableBack: action.status })),
    on(titlebarActions.resetTitlebar, (state, action) => ({ title: '', enableBack: false, hideNotifications: false, hideMenu: false })),
    on(titlebarActions.setTitlebar, (state, action) => ({ ...state, ...action }))
);


export function reducer(state: DocTitlebar | undefined, action: Action) {
    return appReducer(state, action);
}


